import React, { useEffect, useState } from 'react'

import { useTheme } from '@/context/ThemeContext'
import Chat from './Chat'
import { useCustomFetch } from '@/hooks/useCustomFetch'
import { Skeleton } from '@/components/ui/skeleton'

type AskAnythingContentProps = {
  currentThreadId: string
}

const AskAnythingContent: React.FC<AskAnythingContentProps> = ({ currentThreadId }) => {
  const { isDarkMode } = useTheme()
  const customFetch = useCustomFetch()
  const [initialMessages, setInitialMessages] = useState<any[] | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!currentThreadId) return

    const fetchMessages = async () => {
      setIsLoading(true)
      try {
        const messagesResponse = await customFetch(`/chat/messages/getMessagesByThreadId/${currentThreadId}`, 'GET')
        setInitialMessages(messagesResponse.messages || [])
      } catch (error) {
        console.error('Error fetching messages:', error)
        setInitialMessages([])
      } finally {
        setIsLoading(false)
      }
    }
    fetchMessages()
  }, [currentThreadId])

  return (
    <div className="flex-1 h-full overflow-hidden">
      {!isLoading && initialMessages ? (
        <Chat
          threadId={currentThreadId}
          isLoading={isLoading}
          isDarkMode={isDarkMode}
          initialMessages={initialMessages}
        />
      ) : (
        <div className="flex-1 overflow-y-auto px-10 py-6 h-full">
          <div className="w-full mx-auto">
            <div className="flex mb-6 justify-start">
              <div className="flex gap-3 max-w-[80%] flex-row">
                <div>
                  <div
                    className={`rounded-lg p-3 font-manrope text-[14px] font-semibold ${
                      isDarkMode ? 'bg-gray-800 border-gray-700 text-gray-200' : 'bg-white border text-gray-800'
                    }`}
                  >
                    <Skeleton className="h-6 w-[240px]" />
                    <Skeleton className="h-4 w-[180px] mt-2" />
                  </div>
                  <div className="text-xs text-gray-500 mt-1 font-manrope font-semibold text-left">
                    {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default AskAnythingContent
